
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/frelsi/fylla",
      function () {
        return require("private-next-pages/frelsi/fylla/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/frelsi/fylla"])
      });
    }
  